import { compile } from 'path-to-regexp'

// Change a single param in the route to new value
export function changeParam(match, key, value) {
  const toPath = compile(match.path)
  const newParam = { [key]: value }
  return toPath({ ...match.params, ...newParam })
}
